/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export const primary = 'hsl(252 62% 54.9%)';
export const primaryOpacity09 = 'hsl(252deg 62% 55% / 9%)';
